import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { IPageMeta } from '@ztarmobile/zwp-service';
import { ChangePlanShopComponent } from './change-plan-shop/change-plan-shop.component';
import { ChangePlanSummaryComponent } from './change-plan-summary/change-plan-summary.component';
import { NewPlanShopComponent } from './new-plan-shop/new-plan-shop.component';
import { PlansAndFeaturesComponent } from './plans-and-features.component';
import { PlanDetailsListComponent } from './plan-details-list/plan-details-list.component';
import { PLANS_SHOP_ROUTE_URLS } from 'src/app/app.routes.names';

const routes: Routes = [
  { path: '', component: PlansAndFeaturesComponent, children: [
    { path: PLANS_SHOP_ROUTE_URLS.NEW_PLAN, component: NewPlanShopComponent,
      data: {title: `Compare FreeUp's Best & Affordable Cell Phone Plans, Features & Deals | FreeUp Mobile`, description:
    `Need an affordable cell phone plan with fast speeds, international calling, and more? Compare FreeUp Mobile's best and most affordable wireless service plans.`
    } as IPageMeta},
    { path: PLANS_SHOP_ROUTE_URLS.CHANGE_PLAN, component: ChangePlanShopComponent, data: {title: 'Change Plan | FreeUp Mobile', description:
    `Need an affordable cell phone plan with fast speeds, international calling, and more? Compare FreeUp Mobile's best and most affordable wireless service plans.`} as IPageMeta},
    { path: PLANS_SHOP_ROUTE_URLS.CHANGE_PLAN_ID, component: ChangePlanShopComponent, data: {title: 'Change Plan | FreeUp Mobile', description:
    `Need an affordable cell phone plan with fast speeds, international calling, and more? Compare FreeUp Mobile's best and most affordable wireless service plans.`} as IPageMeta},
    { path: PLANS_SHOP_ROUTE_URLS.CHANGE_SUMMARY, component: ChangePlanShopComponent, data: {title: 'Change plan Summary  | FreeUp Mobile', description:
    `Check the details for your change plan request`} as IPageMeta},
    {path: PLANS_SHOP_ROUTE_URLS.DETAILS, component: PlanDetailsListComponent, data: {title: 'Plan Details | FreeUp Mobile', description:
    `Need an affordable cell phone plan with fast speeds, international calling, and more? Compare FreeUp Mobile's best and most affordable wireless service plans.`} as IPageMeta},
    {path: PLANS_SHOP_ROUTE_URLS.DETAILS_ID, component: PlanDetailsListComponent, data: {title: 'Selected Plan Details | FreeUp Mobile'} as IPageMeta},
  ]}
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class PlansAndFeaturesRoutingModule { }
